/**
 * Copyright Warner Bros. Entertainment, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Warner Bros. Entertainment, Inc. and its suppliers, if any.
 * The intellectual and technical concepts contained herein are
 * proprietary to Warner Bros. Entertainment, Inc. and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in process,
 * and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * unlawful and strictly forbidden unless prior written permission is
 * obtained from Warner Bros. Entertainment, Inc.
 */

/* Returns true if the next location differs from the current location.
    Example usage:
    locationNext = { pathname: '/hardac/video-inbox/1234/audio' }
    locationCurrent = {pathname: '/hardac/video-inbox/1234/' }
    comparePathnameSplitSize = 3 Compares first three elements of pathname split: ['hardac', 'video-inbox', '1234']
*/
export const IsLocationDirty = (locationNext, locationCurrent, comparePathnameSplitSize = 3) => {
    if (!locationNext || !locationCurrent) {
        return false;
    }

    let goingTo = locationNext?.pathname?.split('/') || [];
    let current = locationCurrent?.pathname?.split('/') || [];

    for (let i = 1; i <= comparePathnameSplitSize; i++) {
        if (goingTo[i] !== current[i]) {
            return true;
        }
    }

    return false;
};
